import { ViewWorkDataVM, ViewWorkDialogAssignmentAttempt } from '../../../Elearning-Models';

export class ViewWorkDataServiceMockValues {
  public viewWorkData: ViewWorkDataVM = {
   "StudentID":894086,
   "AssignmentID":1504694,
   "AttemptID":1290654,
   "Grade":33,
   "Questions":[
      {
         
         HideFromConsumerCurriculum: false,

         "LessonItemID":1246871,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":0,
         "QuestionText":"In this lesson, you&nbsp;will create linear and exponential equations and inequalities in order to solve problems.&nbsp; Computational as well as real-world math problems can be solved using the equations and inequalities.<br><table class='CE-simple-table-black-border' style='height: 0px; background-color: rgb(229, 224, 236);' cellSpacing='0' cellPadding='10' className='CE-simple-table-black-border'><tbody><tr><td style='background-color: rgb(23, 54, 93);' colSpan='2'><p style='text-align: center;'><strong><font color='#ffffff'>Math Tools</font></strong></p><p><font color='#ffffff' size='2'>Use the tools below, if needed, to complete your lesson</font></p></td></tr><tr><td style='background-color: rgb(219, 229, 241);'>&nbsp;<img src='/Editor/ManagerHandler.ashx?fileID=35595'></td><td style='background-color: rgb(219, 229, 241);'><p><a href='http://web2.0calc.com/' target='_blank'>Scientific Calculator</a></p><p><a href='https://www.desmos.com/' target='_blank'>Graphing Calculator</a></p></td></tr><tr><td style='background-color: rgb(219, 229, 241);'>&nbsp;<img src='/Editor/ManagerHandler.ashx?fileID=35596'></td><td style='background-color: rgb(219, 229, 241);'><p><a href='http://mathbits.com/MathBits/StudentResources/GraphPaper/GraphPaper.htm' target='_blank'>Graph Paper</a></p></td></tr></tbody></table><p>&nbsp;</p>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":null,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Introduction"
      },
      {
         
         HideFromConsumerCurriculum: true,
      "LessonItemID":1246872,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":1,
         "QuestionText":"Which of the following is a linear equation?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":1,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"20=4<sup><font size='3' face='Times New Roman'><em>x</em></font></sup>"
            },
            {
               "IsCorrect":false,
               "Response":"<font size='3' face='Times New Roman'><em>x</em></font><sup>2</sup>+1=5"
            },
            {
               "IsCorrect":true,
               "Response":"500=27+10<font size='3' face='Times New Roman'><em>x</em></font>"
            },
            {
               "IsCorrect":false,
               "Response":"2+3<sup><font size='3' face='Times New Roman'><em>x</em></font></sup>=11"
            }
         ],
         "StudentResponse":[
            "2"
         ],
         "QuestionTitle":"1"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246873,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":2,
         "QuestionText":"Evaluate the following expression for <font size='3' face='Times New Roman'><em>x</em></font>= ‒21.<br><br><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=aa25fd617e65116183139f4f081bd2e4.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mfrac&raquo;&laquo;mn&raquo;4&laquo;/mn&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;/mfrac&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;14&laquo;/mn&raquo;&laquo;/math&raquo;'>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":1,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"2"
            },
            {
               "IsCorrect":false,
               "Response":"‒11"
            },
            {
               "IsCorrect":false,
               "Response":"‒2"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>11</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"2"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246874,
         "QuestionTypeEnumValue":3,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":3,
         "QuestionText":"Evaluate the following expression for <font size='3' face='Times New Roman'><em>x</em></font>=7.<br>&nbsp;<br><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=c044e6dd63df18afd0d42e8c8c05932a.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;5&laquo;/mn&raquo;&laquo;/math&raquo;'>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":1,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>19</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>128</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>54</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>133</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"3"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246875,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":4,
         "QuestionText":"<table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10' className='CE-simple-table-black-border'><tbody><tr><td style='background-color: rgb(146, 205, 220);'>Term&nbsp;</td><td style='background-color: rgb(146, 205, 220);'>Definition&nbsp;</td><td style='background-color: rgb(146, 205, 220);'>Example&nbsp;</td></tr><tr><td>equation&nbsp;</td><td>a mathematical&nbsp;statement in which two expressions are set <strong>equal</strong> to one another&nbsp;</td><td><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=b25f8e1fa59991493e4699be8209ecc2.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mn&raquo;15&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;/math&raquo;'></td></tr><tr><td>inequality&nbsp;</td><td>a mathematical statement in which two expressions are separated by any of the following symbols: <strong>&lt;, &gt;, &le;, &ge;</strong>&nbsp;</td><td><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=be44d142737a64e304c73d8abfc65e68.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mn&raquo;15&laquo;/mn&raquo;&laquo;mo&raquo;$#8804;&laquo;/mo&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;/math&raquo;'></td></tr><tr><td>linear&nbsp;equation&nbsp;</td><td>mathematical&nbsp;equation&nbsp;where the variable, say <font size='4' face='Times New Roman'><em>x</em></font>, is raised to the <strong>power of 1</strong><strong><br></strong><br>*the coefficient of the variable, say <font size='4' face='Times New Roman'><em>x</em></font>, is the constant rate of change&nbsp;</td><td><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=175e46b6bf944eddb3f33e018b37e0ff.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mfrac&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;/mfrac&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;9&laquo;/mn&raquo;&laquo;/math&raquo;'>&nbsp;<br><br>*The constant rate of change is <img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=299b3ff0bb7ea40be24b138008a0353a.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mfrac&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;/mfrac&raquo;&laquo;/math&raquo;'>.</td></tr><tr><td>exponential&nbsp;equation&nbsp;</td><td>mathematical&nbsp;equation&nbsp;where the variable, say <font size='4' face='Times New Roman'><em>x</em></font>, is located in the <strong>exponent</strong> <br><br>*the base number of the exponent must be positive, and cannot be equal to 1&nbsp;in an exponential function</td><td><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=4babcd0bbc3bcf3656bc6cd4da7185d2.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;8&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;1&laquo;/mn&raquo;&laquo;/math&raquo;'>&nbsp;</td></tr><tr><td>'at&nbsp;least'&nbsp;</td><td>in word problems, 'at least' indicates the <strong>greater than or equal to</strong> symbol&nbsp;</td><td>Laura makes at least $20.00 each day at her after school job.<br><br><font size='4' face='Times New Roman'><em>x</em></font> &ge; 20, where <font size='4' face='Times New Roman'><em>x</em></font> represents the amount of money she makes&nbsp;</td></tr><tr><td>'at most'&nbsp;</td><td>in word problems, 'at most' indicates the <strong>less than or equal to</strong> symbol&nbsp;</td><td>James can spend at most&nbsp;$55.00&nbsp;at the store this weekend.<br><br><font size='4' face='Times New Roman'><em>x</em></font> &le; 55, where <font size='4' face='Times New Roman'><em>x</em></font> represents the amount of money&nbsp;he can spend.&nbsp;</td></tr></tbody></table>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":2,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Vocabulary"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246876,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":5,
         "QuestionText":"<font size='4'><strong>Linear Equations</strong></font><br><br>Linear&nbsp;<strong>equations</strong> are valuable in solving real world problems.<br><br>Consider a savings account that was opened with $500.00 in it.&nbsp; Each of the following days, $2.00 will be added to the account and no money will be&nbsp;taken out.&nbsp; Write an equation that represents the number of days, <font size='3' face='Times New Roman'><em>d</em></font>, it takes for the account balance to reach $650.00.<br><br>The following table summarizes what we know about this situation and will help us to write an equation to represent this situation.<br><br><table class='CE-simple-table-black-border' cellspacing='0' cellpadding='10'><tbody><tr><td>initial Amount&nbsp;</td><td>+ daily additional amount&nbsp;</td><td>= desired account balance</td></tr><tr><td>$500.00&nbsp;</td><td>+ 2<font size='4' face='Times New Roman'><em>d</em></font> (2 dollars per day)&nbsp;</td><td>= $650.00&nbsp;</td></tr><tr><td>we are given this information&nbsp;</td><td>a deposit of&nbsp;$2.00&nbsp;each day means we must multiply 2 by the number of days, <font size='4' face='Times New Roman'><em>d</em></font>&nbsp;</td><td>we want to write an equation that yields $650.00 for our desired&nbsp;balance&nbsp;</td></tr></tbody></table><br>Putting it all together, the linear equation we would write is <strong><font style='background-color: rgb(255, 255, 0);'><font>500 + 2<font size='3' face='Times New Roman'><em>d</em></font> = 650</font><br><br><br></font></strong>Based on the equation above, we can collect relevant data points in a table.&nbsp;&nbsp;Substitute the number of days into the expression in order to&nbsp;obtain the account balance.&nbsp; <br><table class='CE-simple-table-black-border' cellspacing='0' cellpadding='10' classname='CE-simple-table-black-border'><tbody><tr><td style='background-color: rgb(141, 179, 226);'><font size='4' face='Times New Roman'><em>d</em></font> (days)&nbsp;</td><td>0&nbsp;</td><td>25&nbsp;</td><td>50&nbsp;</td><td style='background-color: rgb(229, 185, 183);'>75&nbsp;</td><td>100&nbsp;</td></tr><tr><td style='background-color: rgb(141, 179, 226);'>Balance (500+2<font size='4' face='Times New Roman'><em>d</em></font>)&nbsp;</td><td>$500.00&nbsp;</td><td>$550.00&nbsp;</td><td>$600.00&nbsp;</td><td style='background-color: rgb(229, 185, 183);'>$650.00&nbsp;</td><td>$700.00&nbsp;</td></tr></tbody></table><br><font size='3'>*Notice that the account balance increases at a constant rate.&nbsp; Every 25 days the account balance increases by exactly $50.00. This is an indicator that it is&nbsp;a linear function.&nbsp; We can also see that it would take 75 days for the account to reach $650.00.</font><br><br>We can arrive at this answer using algebra as well.<br><br><img style='width: 180px; height: 180px;' src='/Editor/ManagerHandler.ashx?fileID=21341'><br><br><br>Since <font size='3' face='Times New Roman'><em>d</em></font> stands for the number of days, we know that after 75 days the account will contain $650.00.<br><br><br><font color='#4f81bd' size='3'>Extension:</font><br>How many days will it take for the account to contain $1,234.00?<br><br><img style='width: 200px; height: 206px;' src='/Editor/ManagerHandler.ashx?fileID=21362'><br><br>After 367 days of saving, the account will contain $1,234.00.<br><hr><br><strong><font size='4'>Inequalities</font></strong><br>Not only are linear equations valuable in problem solving, but <strong>inequalities</strong> can be helpful as well.&nbsp; The only difference between an inequality and an equation is that the inequality does not set two expression equal to one another.&nbsp; The expressions are separated with one of the four inequality symbols listed.<br><table class='CE-simple-table-black-border' cellspacing='0' cellpadding='10'><tbody><tr><td>Greater Than&nbsp;</td><td>Less Than</td><td>Greater Than<br>Or Equal To</td><td>Less Than<br>Or Equal&nbsp;To&nbsp;</td></tr><tr><td>&gt;&nbsp;</td><td>&lt;&nbsp;</td><td>&ge;&nbsp;</td><td>&le;&nbsp;</td></tr></tbody></table><br>Consider a savings account that was opened with $500.00 in it. Each of the following days, $2.00 will be added to the account and no money will be taken out. Write an equation that represents the number of days, <font size='3' face='Times New Roman'><em>d</em></font>, it takes for the account balance to reach <font color='#ff0000'>more than</font>&nbsp;$650.00.<br><br><font color='#ff0000'>*This scenario is almost the same as above.&nbsp; The only difference is that now we want to know when the balance reaches more than $650.00 and not exactly that amount.<br></font><br>The inequality is, <font><font style='background-color: rgb(229, 185, 183);'><font>500 + 2d <strong>&gt;</strong> 650</font>.</font></font>&nbsp; We use the greater than symbol because we want an account balance of more than $650.00.&nbsp; <br><br>From the previous problem, we&nbsp;already know that it takes 75 days to reach an account balance of $650.00. Therefore it will take more than 75 days to reach an account balance of more than $650.00.&nbsp; <br><font style='background-color: rgb(229, 185, 183);'><br><br><font style='background-color: rgb(255, 255, 255);'>This can be solved using algebra as well.</font><br></font><br><br><img style='width: 180px; height: 185px;' src='/Editor/ManagerHandler.ashx?fileID=21356'><br><br>We can see that it will take more than 75 days for the account to contain more than&nbsp;$650.00.<br><br><img src='/Editor/ManagerHandler.ashx?fileID=21360'><br><br>The number line above can be used to analyze the question.&nbsp; After 83 days of saving, we know that the account will contain more than $650.00 because this value is contained in the shaded area of the graph.<br>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":3,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Linear Equations and Inequalities"
      },
      {
         
         HideFromConsumerCurriculum: false ,
"LessonItemID":1246877,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":6,
         "QuestionText":"<font size='4'>Exponential Equations</font><br><br>When identifying an exponential equation, you must pay close attention to the variable placement.&nbsp; An exponential&nbsp;expression places the variable, say <font size='3' face='Times New Roman'><em>x</em></font>, in the exponent.&nbsp; The expression, <font size='3' face='Times New Roman'><em>x</em></font><sup>2</sup> should not be confused as an exponential expression.&nbsp; Although there is an exponent in the statement, the exponent is an integer and not a variable.&nbsp; The&nbsp;expression 3<sup><em><font size='4' face='Times New Roman'>x</font></em></sup> on the other hand is indeed an exponential expression.&nbsp; <hr><br>Exponential <strong>equations</strong> are also valuable in solving real world problems.&nbsp; Follow the prompts of the interactive presentation below.<br><iframe src='/ispringfile/1521/index.html' height='487' width='650'></iframe><br><br><br><br>We can write a mathematical statement to represent this situation. Let <font size='3' face='Times New Roman'><em>x</em></font> be the number of folds made to the piece of paper.&nbsp; In this case, 2<sup><font size='3' face='Times New Roman'><em>x</em></font></sup> represents the number of resulting rectangular sections.&nbsp; Notice that the variable serves as the exponent of 2.&nbsp; This is an example of an exponential function.<span style='font-family: &quot;Tahoma&quot;,&quot;sans-serif&quot;; font-size: 9pt; mso-fareast-font-family: Calibri; mso-ansi-language: EN-US; mso-fareast-language: EN-US; mso-bidi-language: AR-SA; mso-fareast-theme-font: minor-latin;'><br></span><br><span style='font-family: &quot;Tahoma&quot;,&quot;sans-serif&quot;; font-size: 9pt; mso-fareast-font-family: Calibri; mso-ansi-language: EN-US; mso-fareast-language: EN-US; mso-bidi-language: AR-SA; mso-fareast-theme-font: minor-latin;'>The table below shows show many rectangular sections are created per fold.<br></span><table class='CE-simple-table-black-border' cellspacing='0' cellpadding='10'><tbody><tr><td>2<sup>0</sup>=1<sup>&nbsp;</sup></td><td>Folding the paper 0 times resulted in one rectangular section.&nbsp; *Any number raised to the power of 0 is equal&nbsp;to 1.<sup>&nbsp;</sup></td></tr><tr><td>2<sup>1</sup>=2<sup>&nbsp;</sup></td><td>Folding the paper 1 time resulted in 2 rectangular sections. *Any number raised to the power of 1 is equal to itself.<sup>&nbsp;</sup></td></tr><tr><td>2<sup>2</sup>=4<sup>&nbsp;</sup></td><td>Folding the paper 2 times resulted in 4 rectangular sections. * 2<font size='2'>&bull;</font>2=4</td></tr><tr><td>2<sup>3</sup>=8<sup>&nbsp;</sup></td><td>Folding the paper 3 times resulted in 8 rectangular sections.<sup>&nbsp;</sup>* 2<font size='2'>&bull;</font>2<font size='2'>&bull;</font>2=8</td></tr><tr><td>2<sup>20</sup>=?<sup>&nbsp;</sup></td><td>If you wanted to know how many rectangular sections would be created if you folded the paper 20 times, you&nbsp;raise 2 to the power of 20.&nbsp; <br>2<sup>20</sup>= 1,048,576&nbsp; <sup>&nbsp;</sup></td></tr><tr><td>2<sup><font size='4' face='Times New Roman'><em>x</em></font></sup>=256&nbsp;</td><td>How many folds&nbsp;are necessary to create 256 rectangular sections?&nbsp; You must figure out what exponent will satisfy the equation.<br><br>2<sup>8</sup>=256, 8 folds will result in 256 rectangular sections.&nbsp;</td></tr></tbody></table><sup>&nbsp;<br></sup><font size='3'><font color='#e36c09'>*Notice that the number of rectangular sections created does not increase at a constant rate.&nbsp; This is because an exponential expression is used to evaluate the problem.&nbsp; The number of rectangular sections increase at a more rapid rate as the number of folds increases.</font><br></font><br><font color='#1f497d' size='3'>Extension:</font><br>How many rectangular sections are created after 32 folds?<br><br><img src='/Editor/ManagerHandler.ashx?fileID=21382'><br><br>We know that <font size='3' face='Times New Roman'><em>x</em></font> stands for the number of folds and the output we calculate is the number of rectangular sections.&nbsp; Therefore, after 32 folds, there are 4,294,967,296 rectangular sections.&nbsp;<br><hr><font size='4'>Inequalities</font><br><br>In the section above, we wanted to know how many folds would create 256 rectangular sections.&nbsp; The equation used was 2<font size='4' face='Times New Roman'><sup><em>x</em></sup></font>=256.&nbsp;<br> <br>Suppose we want to know how many folds would create <font color='#ff0000'>256 or more</font> rectangular sections.&nbsp; This inequality would be 2<font size='4' face='Times New Roman'><sup><em>x</em></sup></font>&ge;256.&nbsp; We know that 8 folds create 256 sections, therefore we know that in order to create 256 or more sections, we will need <font color='#ff0000'>greater than or equal to 8 folds.<br><br><br><img src='/Editor/ManagerHandler.ashx?fileID=21386'><br><br><br><strong><font color='#000000'>A number of folds that is greater than or equal to 8 will result in 256 or more rectangular sections.&nbsp; We can see this by the shaded region of the number line above.</font></strong><br></font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":3,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Exponential Equations and Inequalities"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246878,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":7,
         "QuestionText":"When problem solving, different situations will require different models.&nbsp; The following scenario will require two separate equations to be created.&nbsp; Analysis of these equations will help to solve&nbsp;problems and make predictions.<br><hr><br>Taylor is spending the day at Planet Funplex,&nbsp;the local arcade.&nbsp;&nbsp;Her two favorite games are Rocket Launchers and Hoop Shooters.&nbsp;&nbsp;Her goal is to collect as many coins as possible in order to trade them in for prizes.&nbsp; Coins&nbsp;are awarded for winning games; however, each game awards&nbsp;a different amount of coins each game.&nbsp; The chart below describes the details of each game.<br><br><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10' className='CE-simple-table-black-border'><tbody><tr><td style='background-color: rgb(141, 179, 226);'><strong>Rocket Launchers&nbsp;</strong></td><td style='background-color: rgb(195, 214, 155);'><strong>Hoop Shooters</strong></td></tr><tr><td>Before&nbsp;the game starts, Rocket Launchers awards each player a&nbsp;free 200 coins.&nbsp; For each&nbsp;additional game won,&nbsp;10 coins are awarded.&nbsp; For example, if 1 game is won, then 210 coins would be awarded.&nbsp;</td><td>Hoop Shooters awards 1&nbsp;free coin&nbsp;to players who lose their first game; however, you cannot continue playing the game after&nbsp;the first&nbsp;loss.&nbsp;One winning game will result in 3 coins awarded.&nbsp; Each&nbsp;additional&nbsp;game won results in 3 times the amount of coins awarded in the previous game.&nbsp; For example, if 1 game is won, then 3 coins will be awarded.&nbsp; If two games are won, 9 coins will be&nbsp;awarded.&nbsp; If three games are won, 27 coins will be awarded.&nbsp; This pattern continues&nbsp;for any number of games won.&nbsp;&nbsp;</td></tr></tbody></table>&nbsp;&nbsp;&nbsp;&nbsp;<br>Based on this information, we must create two&nbsp;expressions&nbsp;to represent the number of coins&nbsp;awarded after a certain number of games won.&nbsp; Let <font size='3' face='Times New Roman'><em>x</em></font> represent the number of games won in each game.<br><br>The tables below show how many coins would be rewards for up to 4 games won. By analzing these tables, we can determine the expression to write.<br><table style='width: 529px; height: 197px;' cellSpacing='0' cellPadding='10'><tbody><tr><td><strong>Rocket Launchers&nbsp;</strong></td><td><strong>Hoop Shooters</strong></td></tr><tr><td><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10'><tbody><tr><td>Games Won&nbsp;</td><td>Coins Awarded&nbsp;</td></tr><tr><td>0&nbsp;</td><td>200</td></tr><tr><td>1&nbsp;</td><td>210&nbsp;</td></tr><tr><td>2&nbsp;</td><td>220&nbsp;</td></tr><tr><td>3&nbsp;</td><td>230&nbsp;</td></tr><tr><td>4&nbsp;</td><td>240&nbsp;</td></tr></tbody></table></td><td><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10'><tbody><tr><td>Games Won&nbsp;</td><td>Coins Awarded</td></tr><tr><td>0&nbsp;</td><td>1&nbsp;</td></tr><tr><td>1&nbsp;</td><td>3&nbsp;</td></tr><tr><td>2&nbsp;</td><td>9&nbsp;</td></tr><tr><td>3&nbsp;</td><td>27&nbsp;</td></tr><tr><td>4&nbsp;</td><td>81&nbsp;</td></tr></tbody></table></td></tr><tr><td>Expression: 200 + 10<font size='4' face='Times New Roman'><em>x</em></font>&nbsp;</td><td>Expression: 3<sup><font size='4' face='Times New Roman'><em>x</em></font></sup></td></tr></tbody></table><br>The question is, which game should Taylor play in order to earn the most coins in the long run?&nbsp; Looking at the charts so far&nbsp;it seems as though Rocket Launchers would be the best game to play.&nbsp; However, now that we know the expressions, we can substitute values in for <font size='3' face='Times New Roman'><em>x</em></font> in order to predict how many coins will be awarded after <font size='3' face='Times New Roman'><em>x</em></font> amount of games.<br><br><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10' className='CE-simple-table-black-border'><tbody><tr><td style='background-color: rgb(141, 179, 226);'><strong>Rocket Launchers&nbsp;</strong></td><td style='background-color: rgb(195, 214, 155);'><strong>Hoop Shooters</strong></td></tr><tr><td>5 games won:<br>200+10(5)=250 coins&nbsp;</td><td>5 games won:<br>3<sup>5</sup>=243 coins&nbsp;</td></tr><tr><td>6 games won:<br>200+10(6)=260 coins&nbsp;</td><td>6 games won:<br>3<sup>6</sup>=729 coins&nbsp;</td></tr><tr><td>7 games won:<br>200+10(7)=270 coins&nbsp;</td><td>7 games won:<br>3<sup>7</sup>=2,187 coins&nbsp;</td></tr></tbody></table><br><font size='3'><strong>We can see that in the long run, Hoop Shooters is a better game to play.&nbsp; This is because 3<sup><font face='Times New Roman'><em>x</em></font></sup> is an exponential&nbsp;expression while 200+10<font face='Times New Roman'><em>x</em></font> is a linear expression.&nbsp; The exponential expression initially increases at a slower rate, and then increases at a rapid rate later.</strong></font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":3,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Linear Vs. Exponential"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246879,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":8,
         "QuestionText":"Which of the following is a linear inequality?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>5<font size='3' face='Times New Roman'><em>x</em></font> + 2 &le; 12</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>5<font size='3' face='Times New Roman'><em>x</em></font> + 2 = 12</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>5<sup><font size='3' face='Times New Roman'><em>x</em></font></sup>+2 &le; 12</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>5<font size='4' face='Times New Roman'><em><sup>x</sup></em></font> + 2 = 12</font>"
            }
         ],
         "StudentResponse":[
            "0"
         ],
         "QuestionTitle":"1"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246880,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":9,
         "QuestionText":"Which of the following is an exponential equation?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"5<font size='3' face='Times New Roman'><em>x</em></font> + 2 &le; 12"
            },
            {
               "IsCorrect":false,
               "Response":"5<font size='3' face='Times New Roman'><em>x</em></font> + 2&nbsp;= 12"
            },
            {
               "IsCorrect":false,
               "Response":"5<sup><font size='3' face='Times New Roman'><em>x</em></font></sup>+2 &le; 12"
            },
            {
               "IsCorrect":true,
               "Response":"5<sup><font size='3' face='Times New Roman'><em>x</em></font></sup>+2&nbsp;= 12"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"2"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246902,
         "QuestionTypeEnumValue":1,
         "PointsEarned":null,
         "PointsAvailable":0,
         "SequenceNumber":10,
         "QuestionText":"<p>Use the chart below for questions 3 and 4.</p><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10'> <tbody><tr><td>Days Spent Saving </td><td>Amount of Money Saved </td></tr><tr><td>0 </td><td>$12.00 </td></tr><tr><td>1 </td><td>$18.00 </td></tr><tr><td>2 </td><td>$24.00 </td></tr><tr><td>3 </td><td>$30.00 </td></tr><tr><td>4 </td><td>$36.00 </td></tr></tbody> </table><p>&nbsp;</p>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"Chart"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246881,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":11,
         "QuestionText":"Which expression fits the data in the chart?&nbsp; Let <font size='3' face='Times New Roman'><em>x</em></font> represent the days spent saving.<br><br>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>12<font size='3' face='Times New Roman'><em>x</em></font></font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>6<font size='3' face='Times New Roman'><em>x</em></font></font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>6<font size='3' face='Times New Roman'><em>x</em></font> + 12</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>12<font size='3' face='Times New Roman'><em>x </em></font>+ 6</font>"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"3"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246882,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":12,
         "QuestionText":"After 32 days of saving, how much money will be in the account?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$44.00</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>$204.00</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$390.00</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$192.00</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"4"
      },
      {
         
         HideFromConsumerCurriculum: true ,
"LessonItemID":1246883,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":13,
         "QuestionText":"<font color='#000000'>Which table below represents an exponential expression?</font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":4,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<br><img style='width: 400px; height: 96px;' src='/Editor/ManagerHandler.ashx?fileID=21414'><br>"
            },
            {
               "IsCorrect":true,
               "Response":"<br><img style='width: 400px; height: 94px;' src='/Editor/ManagerHandler.ashx?fileID=21412'><br>"
            },
            {
               "IsCorrect":false,
               "Response":"<br><img style='width: 400px; height: 95px;' src='/Editor/ManagerHandler.ashx?fileID=21413'><br>"
            },
            {
               "IsCorrect":false,
               "Response":"<img style='width: 400px; height: 97px;' src='/Editor/ManagerHandler.ashx?fileID=21415'>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"5"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246884,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":14,
         "QuestionText":"Which of the following statements&nbsp;is an exponential equation?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=3f789fc6d84e31a033fe0a15a749155b.png' alt='x squared greater or equal than 36' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;$#8805;&laquo;/mo&raquo;&laquo;mn&raquo;36&laquo;/mn&raquo;&laquo;/math&raquo;'></font>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=ab9a63addf89007be0306c3a8b77c0d0.png' alt='2 over 3 x minus 4 equals 0' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mfrac&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;/mfrac&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;4&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;0&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":true,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=341d21a333494b15010f1248cf52e701.png' alt='6 to the power of x plus 1 equals 2' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;6&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;1&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=12805d29b5e69ae8b0abf3f159853f5a.png' alt='2 to the power of x less than 5' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;$lt;&laquo;/mo&raquo;&laquo;mn&raquo;5&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"1"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246885,
         "QuestionTypeEnumValue":3,
         "PointsEarned":1,
         "PointsAvailable":1,
         "SequenceNumber":15,
         "QuestionText":"Which of the following statements&nbsp;is a linear inequality?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=d30246a408a10395ca4ea26803fd5c04.png' alt='negative 4 x plus 7 equals 5' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;4&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;5&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=9e082dea0bb5859f8f9246f608a3a393.png' alt='2 x left parenthesis x plus 1 right parenthesis greater than 3' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;(&laquo;/mo&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;1&laquo;/mn&raquo;&laquo;mo&raquo;)&laquo;/mo&raquo;&laquo;mo&raquo;$gt;&laquo;/mo&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":true,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=2513fc9a597e65fc729a2723275290a7.png' alt='negative 12 x minus 5 greater or equal than 7' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;12&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;5&laquo;/mn&raquo;&laquo;mo&raquo;$#8805;&laquo;/mo&raquo;&laquo;mn&raquo;7&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=2c104838d363dc932dd3e14d50a76830.png' alt='3 to the power of x plus 1 equals 4' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;+&laquo;/mo&raquo;&laquo;mn&raquo;1&laquo;/mn&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mn&raquo;4&laquo;/mn&raquo;&laquo;/math&raquo;'>"
            }
         ],
         "StudentResponse":[
            "2"
         ],
         "QuestionTitle":"2"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246886,
         "QuestionTypeEnumValue":3,
         "PointsEarned":1,
         "PointsAvailable":1,
         "SequenceNumber":16,
         "QuestionText":"<font color='#000000'>Dennis has $15,000.00 saved in an account in order to buy a used car.&nbsp; The car costs $20,000.00.&nbsp; If he starts saving an additional $35.00 each day, write an equation that represents how many days it will take him to save enough money.&nbsp; Let <font size='3' face='Times New Roman'><em>d</em></font> represent the number of days.</font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>15,000<font size='3' face='Times New Roman'><em>d</em></font> = 20,000</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>35<font size='3' face='Times New Roman'><em>d</em></font> + 15,000&nbsp;= 20,000</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>35<font size='3' face='Times New Roman'><em>d</em></font> = 20,000</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>15,000<font size='3' face='Times New Roman'><em>d</em></font> + 35 = 20,000</font>"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"3"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246887,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":17,
         "QuestionText":"How much money will Dennis have saved in total after 8 days?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$15,000.00</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$19,720.00</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>$15,280.00</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>$20,000.00</font>"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"4"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246888,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":18,
         "QuestionText":"About how&nbsp;many days will it take Dennis to reach his goal of $20,000.00 to buy his used car?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>140&nbsp;days</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>55&nbsp;days</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>143 days</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>83&nbsp;days</font>"
            }
         ],
         "StudentResponse":[
            "3"
         ],
         "QuestionTitle":"5"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246889,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":19,
         "QuestionText":"<p align='center'><img style='width: 250px; height: 218px;' src='/Editor/ManagerHandler.ashx?fileID=20437'><div align='left'>&nbsp;</div></p><br>A Sierpinski Triangle is a famous triangle made up of smaller triangles within it.&nbsp; An&nbsp;iteration is&nbsp;simply a step made in the construction of the&nbsp;triangle.<br><br><strong>One</strong> iteration of the triangle creates <strong>3</strong> new triangles.&nbsp; <strong>Two</strong> iterations of the triangle creates <strong>9</strong> new triangles.&nbsp; <strong>Three</strong> iterations of the triangle creates <strong>27</strong> new triangles.&nbsp; <strong>Four</strong> iterations&nbsp;of the triangle creates <strong>81</strong> new triangles.&nbsp; <br><br>Which exponential function represents the creation of the Sierpinski Triangle?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=261876fdb24ea53b71dde172f644f6fe.png' alt='x cubed' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;/msup&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":true,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=a961da2a050e61699beca84d0afa453a.png' alt='3 to the power of x' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=fc3b214e29fe85eec01c168c5d14093a.png' alt='x squared' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;/msup&raquo;&laquo;/math&raquo;'>"
            },
            {
               "IsCorrect":false,
               "Response":"<img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=64f1803e4183a236264d006183eaadd0.png' alt='2 to the power of x' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;/math&raquo;'>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"6"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246890,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":20,
         "QuestionText":"Following the pattern of the Sierpinski Triangle, how many smaller&nbsp;triangles result after 5 iterations?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>81</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>243</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>729</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>2,187</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"7"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246891,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":21,
         "QuestionText":"Which of the following&nbsp;tables represents a linear expression?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<br><img style='width: 400px; height: 125px;' src='/Editor/ManagerHandler.ashx?fileID=21431'><br>"
            },
            {
               "IsCorrect":false,
               "Response":"<br><img style='width: 400px; height: 128px;' src='/Editor/ManagerHandler.ashx?fileID=21432'><br>"
            },
            {
               "IsCorrect":true,
               "Response":"<br><img style='width: 400px; height: 128px;' src='/Editor/ManagerHandler.ashx?fileID=21433'><br>"
            },
            {
               "IsCorrect":false,
               "Response":"<img style='width: 400px; height: 129px;' src='/Editor/ManagerHandler.ashx?fileID=21434'>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"8"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246892,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":22,
         "QuestionText":"<font color='#000000'>Jill must practice playing the&nbsp;piano for at least 10 hours every week.&nbsp; If she has already practiced for 3 hours this week, which inequality represents how many hours, <font size='3' face='Times New Roman'><em>h</em></font>, she has left to practice?&nbsp; </font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>h</em></font> &gt; 7</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>h</em></font> &lt; 7</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>h </em></font>&ge; 7</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>h</em></font> &le; 7</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"9"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246893,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":23,
         "QuestionText":"Below is an exponential inequality.&nbsp; Which of the following choices will make the inequality true?<br><br><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=641ac9d1db05ce543cf7e827e421f345.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;msup&raquo;&laquo;mn&raquo;2&laquo;/mn&raquo;&laquo;mi&raquo;x&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;-&laquo;/mo&raquo;&laquo;mn&raquo;3&laquo;/mn&raquo;&laquo;mo&raquo;$gt;&laquo;/mo&raquo;&laquo;mn&raquo;61&laquo;/mn&raquo;&laquo;/math&raquo;'>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":5,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>x</em></font>=6</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>x</em></font>=7</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>x</em></font>=5</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>x</em></font>=0</font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"10"
      },
      {
         
         HideFromConsumerCurriculum:true ,
"LessonItemID":1246894,
         "QuestionTypeEnumValue":5,
         "PointsEarned":2,
         "PointsAvailable":4,
         "SequenceNumber":24,
         "QuestionText":"Sharon is making a flower arrangement.&nbsp; The arrangement must have at least 55 flowers in it.&nbsp; Sharon already has 20 flowers to use in her garden.&nbsp; She plans on picking 2 additional flowers from the meadow&nbsp;each&nbsp;minute for the arrangement.&nbsp; <br>Write a mathematical statement that describes this situation&nbsp;using&nbsp;<font size='3' face='Times New Roman'><em>m</em></font> as the number of minutes.&nbsp; <br><br>How many minutes will it take Sharon to collect exactly 40 flowers?<br><br>How many minutes will it take Sharon to collect at least 55 flowers?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":6,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"Suggested Answer: Inequality: 2<font size=\"3\" face=\"Times New Roman\"><em>m</em></font> + 20 &ge; 55<br><br>It will take 10 minutes to collect 40 flowers.<br><br>It will take at least 17.5 minutes to collect at least 55 flowers."
            }
         ],
         "StudentResponse":[
            "extended response"
         ],
         "QuestionTitle":"1"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246895,
         "QuestionTypeEnumValue":5,
         "PointsEarned":1,
         "PointsAvailable":2,
         "SequenceNumber":25,
         "QuestionText":"Based on the table below, determine the exponential function being used.&nbsp; Use <font size='3' face='Times New Roman'><em>x</em></font> as your variable.&nbsp; Then, evaluate this expression for <font size='3' face='Times New Roman'><em>x</em></font>=7.<br><table class='CE-simple-table-black-border' cellSpacing='0' cellPadding='10'><tbody><tr><td>Input (<font size='4' face='Times New Roman'><em>x</em></font>)&nbsp;</td><td>Output</td></tr><tr><td>0&nbsp;</td><td>&nbsp;1</td></tr><tr><td>1&nbsp;</td><td>&nbsp;5</td></tr><tr><td>2&nbsp;</td><td>25&nbsp;</td></tr><tr><td>3&nbsp;</td><td>125</td></tr><tr><td>4&nbsp;</td><td>625&nbsp;</td></tr></tbody></table><br>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":6,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"Suggested Answer: function: <font style=\"background-color: rgb(255, 255, 0);\">5</font><font size=\"3\" face=\"Times New Roman\"><em><sup><font style=\"background-color: rgb(255, 255, 0);\">x</font><br><br></sup></em>When <em>x</em>=7:<br>5<sup>7</sup>=<font style=\"background-color: rgb(255, 255, 0);\">78,125</font></font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"2"
      },
      {
         
         HideFromConsumerCurriculum:false ,
"LessonItemID":1246896,
         "QuestionTypeEnumValue":3,
         "PointsEarned":1,
         "PointsAvailable":1,
         "SequenceNumber":26,
         "QuestionText":"Thomas is on a road trip to San Francisco.&nbsp; At this point, he is already 140 miles away from his house.&nbsp; He continues driving at a rate of 65 miles every hour.&nbsp; Which equation represents the number of hours, <font size='3' face='Times New Roman'><em>h</em></font>, it takes Thomas to&nbsp;be 500 miles away from his house.",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":7,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>140<font size='3' face='Times New Roman'><em>h </em></font>+&nbsp;65 = 500</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>65<font size='3' face='Times New Roman'><em>h </em></font>+ 140 = 500</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>65<font size='3' face='Times New Roman'><em>h </em></font>= 500</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><p><font color='#000000'>140<font size='3' face='Times New Roman'><em>h</em></font> = 500</font></p></font>"
            }
         ],
         "StudentResponse":[
            "1"
         ],
         "QuestionTitle":"1"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246897,
         "QuestionTypeEnumValue":3,
         "PointsEarned":1,
         "PointsAvailable":1,
         "SequenceNumber":27,
         "QuestionText":"Based on the given information, how many hours will it take Thomas to be exactly&nbsp;335 miles away from his house?",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":7,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>1 hour</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>2 hours</font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>3 hours</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>4 hours</font>"
            }
         ],
         "StudentResponse":[
            "2"
         ],
         "QuestionTitle":"2"
      },
      {
         
         HideFromConsumerCurriculum: false,
"LessonItemID":1246898,
         "QuestionTypeEnumValue":3,
         "PointsEarned":0,
         "PointsAvailable":1,
         "SequenceNumber":28,
         "QuestionText":"The accompanying diagram represents the biological process of cell division.<br><br><img src='/Editor/ManagerHandler.ashx?fileID=21462'><br><br>If this process continues, which expression best represents the number of cells at any given time, <font size='3' face='Times New Roman'><em>t</em></font>?<br><br>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":7,
         "AvailableResponses":[
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>t</em></font>+2</font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'>2<font size='3' face='Times New Roman'><em>t</em></font></font>"
            },
            {
               "IsCorrect":false,
               "Response":"<font color='#000000'><font size='3' face='Times New Roman'><em>t</em></font><sup>2</sup></font>"
            },
            {
               "IsCorrect":true,
               "Response":"<font color='#000000'>2<sup><font size='3' face='Times New Roman'><em>t</em></font></sup></font>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"3"
      },
      {
         
         HideFromConsumerCurriculum: true ,
"LessonItemID":1246899,
         "QuestionTypeEnumValue":5,
         "PointsEarned":null,
         "PointsAvailable":2,
         "SequenceNumber":29,
         "QuestionText":"<br><img align='middle' class='Wirisformula' src='/radeditor_wiris/integration/showimage.aspx?formula=53098c20401beb2cbd945c8a2a7bd68a.png' alt='' data-mathml='&laquo;math xmlns=&uml;http://www.w3.org/1998/Math/MathML&uml;&raquo;&laquo;mn&raquo;1&laquo;/mn&raquo;&laquo;mo&raquo;.&laquo;/mo&raquo;&laquo;msup&raquo;&laquo;mn&raquo;5&laquo;/mn&raquo;&laquo;mi&raquo;d&laquo;/mi&raquo;&laquo;/msup&raquo;&laquo;mo&raquo;=&laquo;/mo&raquo;&laquo;mi&raquo;Account&laquo;/mi&raquo;&laquo;mo&raquo;$nbsp;&laquo;/mo&raquo;&laquo;mi&raquo;Balance&laquo;/mi&raquo;&laquo;/math&raquo;'><br>The equation above represents an account balance after <font size='3' face='Times New Roman'><em>d</em></font> days. Make a table of values including the number of days and the account balance in dollars.&nbsp; What will the company account balance be after 25 days?&nbsp; Round answers to the nearest hundredths place.<br><br>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":7,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"Suggested Answer: <table class=\"CE-simple-table-black-border\" cellSpacing=\"0\" cellPadding=\"10\"><tbody><tr><td>Number of Days&nbsp;</td><td>Account Balance&nbsp;</td></tr><tr><td>10&nbsp;</td><td>$57.67&nbsp;</td></tr><tr><td>15&nbsp;</td><td>$437.89&nbsp;</td></tr><tr><td>20&nbsp;</td><td>$3,325.26&nbsp;</td></tr><tr><td style=\"background-color: rgb(255, 255, 0);\">25&nbsp;</td><td style=\"background-color: rgb(255, 255, 0);\">$25,251.17&nbsp;</td></tr><tr><td>30&nbsp;</td><td>$191,751.06&nbsp;</td></tr></tbody></table>"
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"4"
      },
      {
         
         HideFromConsumerCurriculum: true,
"LessonItemID":1246900,
         "QuestionTypeEnumValue":5,
         "PointsEarned":null,
         "PointsAvailable":2,
         "SequenceNumber":30,
         "QuestionText":"<font color='#000000'>Oliver was just offered a new job.&nbsp; The company said that he will receive a signing bonus of $500.00.&nbsp; His hourly rate once he starts will be $12.00.&nbsp; Write an&nbsp;inequality that represents the number of hours, <font size='3' face='Times New Roman'><em>h</em></font>, it will take Oliver to make at most&nbsp;$680.00.&nbsp; Explain what type of function this is and justify your answer.</font>",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":7,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"Suggested Answer: 12<font size=\"3\" face=\"Times New Roman\"><em>h</em></font> + 500&nbsp;&le; 680<br><br>Linear Function: The inequality has a constant rate of change."
            }
         ],
         "StudentResponse":[
            
         ],
         "QuestionTitle":"5"
      },
      {
         
         HideFromConsumerCurriculum: true ,
"LessonItemID":1246901,
         "QuestionTypeEnumValue":4,
         "PointsEarned":0,
         "PointsAvailable":0,
         "SequenceNumber":31,
         "QuestionText":"Write what you have learned about linear and exponential functions and how they are helpful when problem solving.",
         "StandardsCovered":[
            ""
         ],
         "RTIModuleType":null,
         "TemplateComponentType":9,
         "AvailableResponses":[
            {
               "IsCorrect":true,
               "Response":"A suggested answer was not provided for this question."
            }
         ],
         "StudentResponse":[
            "reflection"
         ],
         "QuestionTitle":"Reflection"
      }
   ]
   };

   public viewWorkAssignmentAttemptsDiaglog: ViewWorkDialogAssignmentAttempt[] = [
      {
         AttemptID: 1111,
         SubmitDate: "9/12/2021 5:43 AM"
      },
      {
         AttemptID: 2222,
         SubmitDate: "9/13/2021 6:54PM"
      },
      {
         AttemptID: 3333,
         SubmitDate: ""
      }
   ];
}
